import { format } from 'date-fns';
import { el, de, it, fr } from 'date-fns/locale';

// Locale ανά εσωτερικό κωδικό γλώσσας. Για 'en' αφήνουμε undefined → default en-US του date-fns,
// ώστε η αγγλική εμφάνιση να παραμείνει ακριβώς όπως ήταν.
const LOCALES = { gr: el, de: de, it: it, fr: fr };

/**
 * Πλήρης ημερομηνία.
 *   EN «15 Aug 2026» · EL «15 Αυγ 2026» · DE «15.08.2026» · IT/FR «15/08/2026»
 */
export const formatDateLong = (date, language) => {
  if (!date) return '';
  if (language === 'de') return format(date, 'dd.MM.yyyy');
  if (language === 'it' || language === 'fr') return format(date, 'dd/MM/yyyy');
  return format(date, 'dd MMM yyyy', { locale: LOCALES[language] });
};

/**
 * Σύντομη ημερομηνία (sticky bar κινητού).
 *   EN «Aug 15» · EL «15 Αυγ» · DE «15.08.» · IT/FR «15/08»
 */
export const formatDateShort = (date, language) => {
  if (!date) return '';
  if (language === 'de') return format(date, 'dd.MM.');
  if (language === 'it' || language === 'fr') return format(date, 'dd/MM');
  if (language === 'gr') return format(date, 'dd MMM', { locale: el });
  return format(date, 'MMM dd');
};

/**
 * Όνομα μήνα, για τα μηνύματα διαθεσιμότητας («Μόνο 3 ελεύθερες ημέρες για <Αύγουστο>»).
 */
export const formatMonthName = (year, month, language) => {
  const d = new Date(year, month - 1, 1);
  return format(d, 'LLLL', { locale: LOCALES[language] });
};
